import type { CheckboxDesignTokens } from '@primeuix/themes/types/checkbox';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { tDeep } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/checkbox/index.ts
const ch = tDeep(componentCommon.checkbox);

export const CheckboxTelekomDT: CheckboxDesignTokens = {
  root: {
    disabledBackground: ch.disabled.background,
    checkedHoverBackground: ch.checked.hover.background,
  },
  icon: {
    disabledColor: ch.icon.disabled.color,
  },
};
